export default "__VITE_ASSET__DiZjh0Io__"